import {IResultListItem, IStartListItem} from "@App/types";
import {every} from "lodash";

export function getHidePersonalBestsForRelays(resultListItems: IResultListItem[] | IStartListItem[] | null) {
  if (!resultListItems || resultListItems.length === 0) {
    return false;
  }

  return every(resultListItems, li => !li.personalBest && !li.seasonBest);
}